import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	REPORTS_FILTER_EVENT,
	REPORTS_FOCUS_EVENT,
	REPORTS_SECTION_EVENT,
	SENSOR_MODE_SECTION_EVENT,
} from './events';

const REPORT_SECTIONS = new Set(['maintenance.reports']);
const SENSOR_SECTIONS = new Set(['maintenance.sensor_mode']);

/**
 * Open the Maintenance Reports accordion.
 * @return {Promise<void>} completion acknowledgement
 */
export function openReportsSection() {
	return openResourceSection(
		REPORTS_SECTION_EVENT,
		'maintenance.reports',
		REPORT_SECTIONS,
	);
}

/**
 * Open the Sensor Mode accordion on the Reports tab.
 * @return {Promise<void>} completion acknowledgement
 */
export function openSensorModeSection() {
	return openResourceSection(
		SENSOR_MODE_SECTION_EVENT,
		'maintenance.sensor_mode',
		SENSOR_SECTIONS,
	);
}

/**
 * Apply a Reports list query or column filter.
 * @param {object} command filter command
 * @return {Promise<void>} completion acknowledgement
 */
export function applyReportsFilter(command) {
	const params = command.params || {};
	const query = String(params.query || '').trim();
	const filters = {};
	Object.entries(params).forEach(([key, value]) => {
		if (key === 'query' || key === 'resource') return;
		const text = String(value ?? '').trim();
		if (text) filters[key] = text;
	});
	if (!query && !Object.keys(filters).length) {
		return Promise.reject(new Error('invalid_reports_filter'));
	}
	return dispatchAcknowledgedEvent(REPORTS_FILTER_EVENT, {
		query,
		...filters,
		resource: 'report',
	});
}

/**
 * Focus a resolved report row, and download it when asked.
 * @param {object} command focus command
 * @return {Promise<void>} completion acknowledgement
 */
export function focusReport(command) {
	const entityId = command.params?.entity_id;
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_report_entity'));
	}
	return dispatchAcknowledgedEvent(REPORTS_FOCUS_EVENT, {
		entityId,
		action_target: command.params?.action_target,
		action_activation: command.params?.action_activation,
		resource: 'report',
	});
}
